// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"_2M5CYS4g","opened":"_6yYgUVYF"};